<div *ngIf="(state$ | async) as state">
  <div *ngIf="state.visible" class="loader-backdrop">
    <div class="loader-box text-center">
      <div class="spinner-border text-primary mb-4" role="status"></div>

      <div class="fw-semibold fs-5 text-gray-800 loader-message">
        {{ state.message }}
      </div>
    </div>
  </div>
</div>